import { Route, BrowserRouter as Router, Routes } from "react-router";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import HomeLayout from "./layout/HomeLayout";
import SignIn from "./pages/AuthPages/SignIn";
import Home from "./pages/Home/Home";
import TaskInbox from "./pages/MainPages/TaskInbox";
import ExamTaskInbox from "./pages/MainPages/ExamTaskInbox";
import TaskDetail from "./pages/MainPages/TaskDetail";
import ExamTaskDetail from "./pages/MainPages/ExamTaskDetail";
import Summary from "./pages/MainPages/Summary"; // Importar la página Summary

import NotFound from "./pages/OtherPage/NotFound";

import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Dashboard Layout */}
          <Route element={<HomeLayout />}>
            <Route index path="/" element={<Home />} />
          </Route>

          {/* Protected App Layout */}
          <Route
            element={
              <PrivateRoute>
                <AppLayout />
              </PrivateRoute>
            }
          >
            <Route index path="/tasks" element={<TaskInbox />} />
            <Route index path="/exam-tasks" element={<ExamTaskInbox />} />

            <Route path="/tasks/:taskID" element={<TaskDetail />} />
            <Route path="/exam-tasks/:taskID" element={<ExamTaskDetail />} />

            <Route
              path="/summary"
              element={
                <PrivateRoute roles={["is_superuser"]}>
                  <Summary />
                </PrivateRoute>
              }
            />
          </Route>

          {/* Auth Layout */}
          <Route element={<AuthLayout />}>
            <Route path="/signin" element={<SignIn />} />
          </Route>

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
